import React, { Fragment, PureComponent, ReactNode } from 'react';
import Price from '~/utils/Price';
import {
	Sentence as ApiSentence,
	SentencePart,
	SentencePartTypes,
} from '~/MedicinalBrandsAnalytics/VirtualBrand/Reimbursement';
import Tooltip from '~/UI/Tooltip';
import DarkTooltipStyles from '~/UI/Tooltip/dark.less';

import styles from './styles.less';

interface Props {
	sentence: ApiSentence;
	packageNameRenderer(packageName: string): ReactNode;
}

export default class Sentence extends PureComponent<Props> {
	renderPart(part: SentencePart) {
		const { packageNameRenderer } = this.props;

		switch (part.type) {
			case SentencePartTypes.brandName:
				return part.text;

			case SentencePartTypes.comma:
				return ',';

			case SentencePartTypes.countryName:
				return part.name;

			case SentencePartTypes.monetaryAmount:
				return <strong>{new Price(part.amount, part.currency).roundedHumanFormat()}</strong>;

			case SentencePartTypes.packageName:
				return packageNameRenderer(part.text);

			case SentencePartTypes.text:
				return part.text;

			case SentencePartTypes.tooltip:
				return (
					<Tooltip reference={<u>{part.text}</u>} styles={DarkTooltipStyles}>
						<p className={styles.tooltipContent}>{part.tooltip}</p>
					</Tooltip>
				);

			default:
				return 'text' in part ? part['text'] : '';
		}
	}

	render() {
		const { sentence } = this.props;
		const lastIndex = sentence.parts.length - 1;

		return sentence.parts.map((part, i) => (
			<Fragment key={JSON.stringify(part)}>
				{i > 0 && part.type !== SentencePartTypes.comma ? ' ' : null}
				{this.renderPart(part)}
				{i === lastIndex ? '.' : null}
			</Fragment>
		));
	}
}
